import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import renderSelectWithCheckboxesField from '../../../shared/components/form/SelectWithCheckboxes';

const buttonTop = {
  marginTop: '15px',
};

const marginBottom = {
  marginBottom: '40px',
};

class RenderPackagesFlows extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
    options: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  render() {
    const {
      fields,
      meta: { error, submitFailed },
      options,
    } = this.props;
    const { moveToUp, moveToDown } = RenderPackagesFlows;
    const { instantFlows } = options;

    return (
      <div className="form__form-group">
        <ButtonToolbar style={buttonTop}>
          <Button color="success" size="sm" onClick={() => fields.push({})}>
            Добавить бонус
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
        {fields.map((bonus, index) => (
          <div key={index} className="form__form-group" style={marginBottom}>
            <span className="form__form-group-label">Бонус # {index + 1}</span>
            <div className="form__form-group-field">
              <Field
                name={`${bonus}.bonus`}
                component={renderSelectWithCheckboxesField}
                type="text"
                placeholder="Выберите бонус"
                preText="Пакет "
                options={instantFlows}
              />
              <div className="form__form-group-icon">
                <ArrowUpBold onClick={() => moveToUp(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RenderPackagesFlows;
